__turbopack_context__.v({
  "time": "resend-verification-module-scss-module__-WkUna__time",
});
